// extracted by mini-css-extract-plugin
export default {"dFlex":"sidebar_dFlex__-3EPc","outlet":"sidebar_outlet__PFGGo","fixedSideBar":"sidebar_fixedSideBar__HKlZ8"};